import React, {Component} from 'react';
import './App.css';
import MeteoPanel from './graphql/MeteoPanel';

import 'semantic-ui-css/semantic.min.css'

function App() {
  //const url = "https://alerty.sensorbox.eu/cas_alerty/webapp";
  const url = "https://mzo-pruszkow.panel.test.sensorbox.pl/webapp"
  return (
    // <MeteoPanel configUrl="https://pmpro.dacsystem.pl/webapp" dataUrl="https://hesgdynia.dustbox.pl/cas_envag/webapp"/>
    <MeteoPanel configUrl={url} dataUrl={url} />
  );
}

export default App;
